import {
  checkLoadedFundraisingProject,
  loadFundraisingProject,
} from '@/services/session/details.service';

export const loadFundraisingProjectGuard = async (
  id: string
): Promise<boolean> => {
  let hasDetail = await checkLoadedFundraisingProject(id);
  if (!hasDetail) {
    hasDetail = await loadFundraisingProject(id);
  }
  return hasDetail;
};
